<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="error white--text">
        <v-toolbar-title v-if="fromDate != '' && toDate != ''"
          >Cash Flow: {{ fromDate }} --- {{ toDate }}</v-toolbar-title
        >

        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <div class="flex-grow-1"></div> -->
        <searchDate :searching="searching" :SearchFun="OnSearch"></searchDate>
        <v-spacer></v-spacer>
        <v-btn
          v-if="sales.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-card flat>
          <v-card-title>
            <div>
              <cashDisplay
                small
                :isloading="isloading"
                :Balance="OldBalance"
              ></cashDisplay>
            </div>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div>
              <!-- {{ Transaction }} -->
              <cashDisplay
                small
                :isloading="isloading"
                :Balance="TotalOldBalance"
              ></cashDisplay>
            </div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              single-line
              hide-details
              class="d-print-none"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :hide-default-footer="hideFooter"
            flat
            :headers="headers"
            :items="Transaction"
            :search="search"
            @current-items="FilteredList = $event"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="All_In"
                    colorName="teal"
                    small
                  ></cashDisplay>
                </div>
                <v-divider class="mx-4" inset vertical></v-divider>

                <v-spacer></v-spacer>
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="All_OUT"
                    colorName="error"
                    small
                  ></cashDisplay>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.in`]="{ item }">
              <!-- <p>{{ FilteredList }}</p> -->
              <div v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </div>
            </template>
            <template v-slot:[`item.out`]="{ item }">
              <div v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </div>
            </template>
            <template v-slot:[`item.Ref`]="{ item }">
              <!-- <div>
                {{
                  item &&
                    item.Ref &&
                    item.Ref.toString()
                      .split("-")[0]
                      .toUpperCase()
                }}
              </div> -->
              {{ item.Ref }}
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-toolbar flat color="grey lighten-4">
          <v-spacer></v-spacer>
          <div>
            <cashDisplay
              small
              :isloading="isloading"
              :Balance="Total_IN_OUT"
            ></cashDisplay>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    cashDisplay: () => import("@/components/coman/cashView"),
    searchDate: () => import("@/components/util/searchDate.vue"),
  },
  data() {
    return {
      SalesRepo: "/Reports/cash",
      searching: false,
      isloading: false,
      hideFooter: false,
      search: "",
      fromDate: "",
      toDate: "",
      FilteredList: [],
      OldBalance: [],
      sales: [],
      TotalBalance: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Description", value: "Name" },
        { text: "IN", value: "in" },
        { text: "OUT", value: "out" },
        { text: "Balance", value: "total" },
        { text: "Account", value: "AccountName" },
        { text: "Details", value: "Details" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    Total_IN_OUT() {
      // if (!this.sales.length) return [];
      let total = [...(this.sales || []), ...(this.OldBalance || [])].reduce(
        (result, item) => {
          let { Amount } = result[item.AmountType] || { Amount: 0 };
          // let Str = JSON.stringify(item);
          // if (Str[Str.search(new RegExp(this.search, "i"))] || !this.search)
          result[item.AmountType] = {
            Amount: Amount + item.Amount,
            AmountType: item.AmountType,
          };
          return result;
        },
        {}
      );
      return Object.keys(total).map(key => total[key]);
    },
    TotalOldBalance() {
      if (!this.OldBalance.length) return [];
      let total = this.OldBalance.reduce((result, item) => {
        let { Amount } = result[item.AmountType] || { Amount: 0 };
        result[item.AmountType] = {
          Amount: Amount + item.Amount,
          AmountType: item.AmountType,
        };
        return result;
      }, {});
      return Object.keys(total).map(key => total[key]);
    },

    All_In() {
      if (!this.FilteredList.length) return [];
      let total = this.FilteredList.filter(item => item.Acc === "Dr").reduce(
        (result, item) => {
          // let  Amount = 0;
          let temp =
            result[item.AmountType] &&
            result[item.AmountType][item.AccountName];

          let { Amount } = temp || { Amount: 0 };

          result[item.AmountType] = {
            ...(result[item.AmountType] || {}),
            [item.AccountName]: {
              Amount: Amount + item.Amount,
              AmountType: item.AmountType,
              AccountName: item.AccountName,
            },
          };
          return result;
        },
        {}
      );

      return Object.keys(total).reduce((result, key) => {
        result.push(...Object.keys(total[key]).map(item => total[key][item]));
        // console.log(result);
        return result;
      }, []);
    },
    All_OUT() {
      if (!this.FilteredList.length) return [];
      let total = this.FilteredList.filter(item => item.Acc === "Cr").reduce(
        (result, item) => {
          // let  Amount = 0;
          let temp =
            result[item.AmountType] &&
            result[item.AmountType][item.AccountName];

          let { Amount } = temp || { Amount: 0 };

          // console.log(item);

          result[item.AmountType] = {
            ...(result[item.AmountType] || {}),
            [item.AccountName]: {
              Amount: Amount + item.Amount,
              AmountType: item.AmountType,
              AccountName: item.AccountName,
            },
          };
          return result;
        },
        {}
      );

      return Object.keys(total).reduce((result, key) => {
        result.push(...Object.keys(total[key]).map(item => total[key][item]));
        // console.log(result);
        return result;
      }, []);
    },
    OldByKey() {
      return this.TotalOldBalance.reduce((result, newTrn) => {
        result[newTrn.AmountType] = newTrn.Amount;
        return result;
      }, {});
    },
    ReverseSales() {
      if (Array.isArray(this.sales)) return this.sales;
      return [];
    },
    Transaction() {
      let runingTotal = this.OldByKey;
      return this.ReverseSales.map(tran => {
        let old = runingTotal[tran.AmountType] || 0;
        let total = old + tran.Amount;
        runingTotal[tran.AmountType] = total;
        return { ...tran, total: total && total.toLocaleString() };
      });
      // return tran;
    },
  },
  methods: {
    async PrintPage() {
      this.hideFooter = true;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.hideFooter = false;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];
      this.TotalBalance = [];

      this.searching = true;
      this.isloading = true;
      let balanceReq = `${this.SalesRepo}/balance`;
      let { yesterDay } = this.Current(from);

      axios
        .all([
          this.GetReq(),
          this.GetReq(balanceReq, { from: null, to: yesterDay }),
        ])
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;

          this.sales = result[0].data && result[0].data.reverse();
          this.OldBalance = result[1].data;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },
    GetReq(url, query) {
      if (!url) url = this.SalesRepo;
      if (!query) query = { from: this.fromDate, to: this.toDate };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    loadSales(from) {
      try {
        // this.$store
        //   .dispatch("GET_ONLY", this.SalesRepo)
        this.searching = true;
        this.isloading = true;
        let balanceReq = `${this.SalesRepo}/balance`;
        let { yesterDay } = this.Current(from);

        let MultReq = [
          this.GetReq(),
          this.GetReq(balanceReq, { from: null, to: yesterDay }), // Show Old Balance
        ];

        axios
          .all(MultReq)
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value[0].data && value[0].data.reverse();
            this.OldBalance = value[1].data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    const { date } = this.Current();
    // console.log("hellow");
    this.fromDate = date;
    this.toDate = date;
    this.loadSales(this.fromDate, this.toDate);
  },
};
</script>
